import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, DashboardModule, Link } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCampaign'
import useCampaignLinks from '@hooks/useCampaignLinks'
import useMediaLink from '@hooks/useMediaLink'

import MediaLink from '@components/MediaLinkListItem'

import { CampaignModel } from '@models/types'

type ToursAndLinksProps = {
    campaign: CampaignModel,
    readOnly?: boolean,
}

const ToursAndLinks = (props: ToursAndLinksProps) => {
  const { campaign, readOnly } = props

  const combinedCampaignLinksPayload = useCampaignLinks(campaign, { performHttpRequests: !!campaign.id })
  const { campaignLinks, hasCampaignLinks } = combinedCampaignLinksPayload

  const initMediaLink = {
    linkable_id: campaign.id,
    linkable_type: 'Campaign',
  }

  const {
    callbacks: { createOrEditMediaLink },
    loading,
  } = useMediaLink(initMediaLink)

  const { campaignEditDetailsUrl } = generateUrls({ id: campaign.id })

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={
        readOnly && (
          <Link href={campaignEditDetailsUrl} textProps={{ fontSize: 'small' }}>
            Manage
          </Link>
        )
      }
      loading={loading}
      title="Tours & Links"
    >
      {hasCampaignLinks && (
        <DashboardModule.ScrollableSection>
          {campaignLinks.map(link => (
            <MediaLink key={link.id} mediaLink={link} readOnly={readOnly} />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasCampaignLinks && readOnly && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No links in this campaign
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            You can add Tours & Links in the Details page. Once added they will be included when exporting to portals.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!readOnly && (
        <DashboardModule.Footer boxProps={{ borderTop: !hasCampaignLinks ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditMediaLink()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Link
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      )}
    </DashboardModule>
  )
}

export default ToursAndLinks
